import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AppCtx = createContext(null);

export const AppProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [lang, setLang] = useState(localStorage.getItem("lang") || "hu");
  const [currency, setCurrency] = useState(localStorage.getItem("currency") || "HUF");

  const checkAuth = useCallback(async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
      if (r.data.lang_pref) { setLang(r.data.lang_pref); localStorage.setItem("lang", r.data.lang_pref); }
      if (r.data.currency_pref) { setCurrency(r.data.currency_pref); localStorage.setItem("currency", r.data.currency_pref); }
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) { setLoading(false); return; }
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };
  const register = async (email, password, name) => {
    const r = await api.post("/auth/register", { email, password, name });
    localStorage.setItem("token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("token");
    setUser(null);
  };
  const refresh = async () => { await checkAuth(); };

  const changeLang = (l) => { setLang(l); localStorage.setItem("lang", l); if (user) api.patch("/auth/prefs", { lang_pref: l }).catch(()=>{}); };
  const changeCurrency = (c) => { setCurrency(c); localStorage.setItem("currency", c); if (user) api.patch("/auth/prefs", { currency_pref: c }).catch(()=>{}); };
  const updateBalance = (cur, value) => {
    setUser(prev => prev ? ({ ...prev, [cur === "HUF" ? "balance_huf" : "balance_eur"]: value }) : prev);
  };

  return (
    <AppCtx.Provider value={{ user, loading, lang, currency, login, register, logout, refresh, changeLang, changeCurrency, updateBalance }}>
      {children}
    </AppCtx.Provider>
  );
};

export const useApp = () => useContext(AppCtx);
